module.exports = __webpack_public_path__ + "media/customizations/dobsonranch/dashboard-a0d01427b724b196836932888f2beaef.jpg";